import { useState, useEffect, useCallback} from 'react';

const useTimeout = (delay = 6000) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	useEffect(() => {
		let timerId: any = null;

		if(isOpen) {
			timerId = setTimeout(() => {
				setIsOpen(false);
			}, delay);
		}

		return () => {
			clearTimeout(timerId);
		}
	}, [isOpen, delay]);

	const onOpen = useCallback(() => { setIsOpen(true); }, []);
	const onClose = useCallback(() => { setIsOpen(false); }, []);

	return {
		isOpen,
		onOpen,
		onClose
	}
}

export default useTimeout;
